export default {
	idOrgao: null,
	permissoes: [],
}
